// extracted by mini-css-extract-plugin
export var container = "dialogiLabel-module--container--0df2f";
export var letnik = "dialogiLabel-module--letnik--5629e";
export var leto = "dialogiLabel-module--leto--900ba";
export var stevilka = "dialogiLabel-module--stevilka--cdf8f";